import { object } from "yup";
import { validations } from "./validations";
import {
  runValidation,
  runValidationOnBlur,
} from "./validationfunction";

export function newsletterForm() {
  // STEP 1: Select your form
  const myForm = document.querySelector("#newsletterForm");

  // STEP 2: Select the fields of your form.
  const formfields = {
    email: myForm.querySelector("#email"),
  };

  // STEP 3: Define a Yup schema for email validation
  // You need to import the validations from the validations.js file where you can find some common validations with yup. If you need another validation you should add it to the validations object.

  const schema = object({
    email: validations.email,
  });

  // STEP 4: This function get's the values of the form's fields. Update the fields accordingly.
  const validationObject = () => {
    const validationObject = {
      email: formfields.email.value,
    };
    return validationObject;
  };

  // STEP 5: In this function you add the code you want to run when the form passes the validations and is ready for submition.
  function successSubmit(values) {
    console.log("form sucess", values);
  }

  // This two functions run the validations the one on submit and the other on blur.
  runValidation(myForm, formfields, validationObject, schema, successSubmit);
  runValidationOnBlur(myForm, formfields, validationObject, schema);
}
